import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "card", "searchInput"]
  static values = {
    sortBy: String,
    sortDirection: { type: String, default: "asc" },
    searchQuery: { type: String, default: "" }
  }

  connect() {
    // Initialize sorting and ensure all cards are visible
    this.searchQueryValue = ""
    this.searchInputTarget.value = ""
    this.filterAndSort()
  }

  search(event) {
    const query = event.target.value.toLowerCase().trim()
    console.log("Search query:", query) // Debug log
    this.searchQueryValue = query
    this.filterAndSort()
  }

  sort() {
    this.filterAndSort()
  }

  filterAndSort() {
    const cards = Array.from(this.cardTargets)
    const query = this.searchQueryValue
    console.log("Filtering with query:", query, "Length:", query.length) // Debug log

    // First, handle visibility
    cards.forEach(card => {
      if (!query) {
        // If query is empty, make sure card is visible
        card.classList.remove('hidden')
      } else {
        // Otherwise, check if card matches search
        const text = this.getSearchableText(card).toLowerCase()
        const visible = text.includes(query)
        if (visible) {
          card.classList.remove('hidden')
        } else {
          card.classList.add('hidden')
        }
      }
    })

    // Get all visible cards
    const visibleCards = cards.filter(card => !card.classList.contains('hidden'))
    console.log("Visible cards:", visibleCards.length) // Debug log

    // Sort visible cards if we have a sort criteria
    if (this.sortByValue) {
      const direction = this.sortDirectionValue
      visibleCards.sort((a, b) => {
        let valueA = this.extractValue(a, this.sortByValue)
        let valueB = this.extractValue(b, this.sortByValue)

        if (direction === "desc") {
          [valueA, valueB] = [valueB, valueA]
        }

        if (typeof valueA === 'number' && typeof valueB === 'number') {
          return valueA - valueB
        }

        return String(valueA).localeCompare(String(valueB))
      })
    }

    // // Clear the container
    // while (this.containerTarget.firstChild) {
    //   this.containerTarget.removeChild(this.containerTarget.firstChild)
    // }

    // // Add all visible cards back in sorted order
    // visibleCards.forEach(card => {
    //   this.containerTarget.appendChild(card)
    // })

    // Update empty state message
    this.updateEmptyState(visibleCards.length === 0)
  }

  getSearchableText(card) {
    const name = card.querySelector("h3").textContent || ""
    const team = card.querySelector("p")?.textContent || ""
    const stats = Array.from(card.querySelectorAll('[data-stat]'))
      .map(stat => stat.textContent)
      .join(" ")
    return `${name} ${team} ${stats}`
  }

  extractValue(card, sortBy) {
    switch (sortBy) {
      case "name":
        return card.querySelector("h3").textContent.trim()
      case "games":
        return parseInt(card.querySelector('[data-stat="games"]')?.textContent || "0")
      case "goals":
        return parseInt(card.querySelector('[data-stat="goals"]')?.textContent || "0")
      case "assists":
        return parseInt(card.querySelector('[data-stat="assists"]')?.textContent || "0")
      case "points":
        return parseInt(card.querySelector('[data-stat="points"]')?.textContent || "0")
      default:
        return ""
    }
  }

  toggleSort(event) {
    const newSortBy = event.currentTarget.dataset.sortValue
    
    if (this.sortByValue === newSortBy) {
      // Toggle direction if clicking the same sort option
      this.sortDirectionValue = this.sortDirectionValue === "asc" ? "desc" : "asc"
    } else {
      // New sort option, default to ascending
      this.sortByValue = newSortBy
      this.sortDirectionValue = "asc"
    }

    // Update active states
    this.updateSortButtons()
    this.sort()
  }

  updateSortButtons() {
    const buttons = document.querySelectorAll("[data-sort-value]")
    buttons.forEach(button => {
      const isActive = button.dataset.sortValue === this.sortByValue
      button.classList.toggle("bg-blue-600", isActive)
      button.classList.toggle("text-white", isActive)
      button.classList.toggle("bg-gray-100", !isActive)
      button.classList.toggle("text-gray-700", !isActive)
      
      // Update direction indicator
      const indicator = button.querySelector(".sort-direction")
      if (indicator) {
        if (isActive) {
          indicator.textContent = this.sortDirectionValue === "asc" ? "↑" : "↓"
          indicator.classList.remove("opacity-0")
        } else {
          indicator.classList.add("opacity-0")
        }
      }
    })
  }

  updateEmptyState(isEmpty) {
    let emptyState = this.element.querySelector('[data-empty-state]')
    if (isEmpty) {
      if (!emptyState) {
        emptyState = document.createElement('div')
        emptyState.setAttribute('data-empty-state', '')
        emptyState.className = 'col-span-full text-center py-12 text-gray-500'
        emptyState.textContent = 'No players found matching your search.'
        this.containerTarget.appendChild(emptyState)
      }
    } else if (emptyState) {
      emptyState.remove()
    }
  }
} 